import { gql } from '@apollo/client';

export const EMAIL_TEMPLATE_FIELDS = gql`
  fragment EmailTemplateFields on emailTemplate {
    id
    description
    category
    mailchimpListId
    fromName
    replyTo
    siteId
    site {
      id
      name
      city
      property
      url
    }
  }
`;
